<div class="actions">
    <wms-search id="prefab-props-search-box" name="prefab-props-search-box" width="20em" (onSearch)="searchPageParams($event)"></wms-search>
</div>
<div class="widgets-list-container">
    <wms-tree id="prefab-props-search-box"  [data]="bindVariableService.pageParamsTree" (nodeClick)="bindVariableService.handleTreeNodeClick($event)" sortBy="id" icontype="plus" [externalSearchKey]="pageParamSearchKey" [selectedNode]="bindVariableService.selectedNodeInBindDialog['page-param']"></wms-tree>
</div>